import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as ChevronLeft } from '../../../assets/chevron_left.svg';
import { ReactComponent as PlexLogoSmallSvg } from '../../../assets/plex_logo.svg';
import { GetLoggedInUserQuery } from '../../../graphql/gen/types';
import { colorPalette, rightBorderStyle } from '../../../theme';
import { SharedNavBar } from '../../shared/navigation/SharedNavBar';
import { SettingsMenu } from './SettingsMenu';
import { SettingsPages } from './SettingsPages';

type Props = {
  userProfile: NonNullable<GetLoggedInUserQuery['currentUser']>;
};

export const SettingsContainer = (props: Props): React.ReactElement => {
  const { userProfile } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <SharedNavBar>
        <Link to={'/'} className={classes.logoContainer}>
          <PlexLogoSmallSvg className={classes.logo} />
        </Link>
        <Link to={'/'} className={classes.backButton}>
          <ChevronLeft className={classes.logo} />
          Return to plex
        </Link>
      </SharedNavBar>
      <div className={classes.settingsContainer}>
        <div className={classes.sidebar}>
          <div className={classes.bottomButtons}>
            {/* <PlexIconButton
              className={classNames(classes.avatarButton, classes.buttonUnselected)}
              color={ButtonColor.Purple}
              tooltip={'Analytics'}
              tooltipPlacement={'right'}
              SvgIcon={Analytics}
              size={IconButtonSize.Normal}
              onClick={(): void => console.log('not implemented')}
            />
            <PlexIconButton
              className={classes.avatarButton}
              color={ButtonColor.Purple}
              tooltip={'Settings'}
              tooltipPlacement={'right'}
              iconView={<Avatar alt={userProfile.email} src={userProfile.picture} className={classes.avatar} />}
              size={IconButtonSize.Normal}
              onClick={(): void => console.log('already here')}
            /> */}
          </div>
        </div>
        <div className={classes.content}>
          <SettingsMenu userProfile={userProfile} />
          <div className={classes.contentContainer}>
            <SettingsPages userProfile={userProfile} />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const SMALL_SIDEBAR_WIDTH = 70;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backButton: {
      height: 80,
      borderRadius: 0,
      fontSize: 20,
      fontWeight: 600,
      color: colorPalette.purpleGray._500,
      letterSpacing: 0.15,
      alignItems: 'center',
      display: 'flex',
      textDecoration: 'none',
    },
    logo: {
      width: 40,
    },
    logoContainer: {
      width: SMALL_SIDEBAR_WIDTH,
      height: 80,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ...rightBorderStyle,
    },
    sidebar: {
      display: 'flex',
      backgroundColor: '#fff',
      height: '100%',
      ...rightBorderStyle,
      width: SMALL_SIDEBAR_WIDTH,
      position: 'relative',
    },
    bottomButtons: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
    },
    avatarButton: {
      width: '100%',
      height: SMALL_SIDEBAR_WIDTH,
      borderRadius: 0,
    },
    buttonUnselected: {
      backgroundColor: '#fff',
    },
    avatar: {
      width: 24,
      height: 24,
    },
    settingsContainer: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      width: '100%',
      flex: 1,
    },
    content: {
      display: 'flex',
      flex: 1,
      marginTop: 80,
      backgroundColor: '#fff',
      flexDirection: 'row',
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflow: 'scroll',
    },
  })
);
